module.exports = __webpack_public_path__ + "static/4104-963eec5b323654456c9ef07a76602bea.png";